import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ethers } from 'ethers';
import logo from '../assets/logobot.png';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import TextToVideo from '../components/TextToVideo';

const VideoPage = () => {
  const [account, setAccount] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    checkWalletConnection();
  }, []);

  const checkWalletConnection = async () => {
    if (window.ethereum) {
      try {
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const accounts = await provider.listAccounts();
        if (accounts.length > 0) {
          setAccount(accounts[0].address);
        }
      } catch (err) {
        console.error('Error checking wallet connection:', err);
      }
    }
  };

  const connectWallet = async () => {
    if (loading) return;
    setLoading(true);
    setError('');

    try {
      if (!window.ethereum) {
        throw new Error('Please install MetaMask to use this feature');
      }

      const accounts = await window.ethereum.request({
        method: 'eth_requestAccounts'
      });
      
      if (accounts && accounts.length > 0) {
        setAccount(accounts[0]);
      }
    } catch (err) {
      console.error('Wallet connection error:', err);
      setError(err.message || 'Failed to connect wallet');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      background: 'linear-gradient(135deg, #13111C 0%, #1a1726 50%, #1f1c2e 100%)'
    }}>
      <Navbar />
      
      <main style={{ 
        flex: 1,
        color: 'white',
        padding: '30px',
        paddingTop: '100px' // Account for fixed navbar
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '40px'
          }}>
            <Link to="/members" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '15px',
              textDecoration: 'none',
              color: 'white',
              background: 'rgba(138, 43, 226, 0.1)',
              padding: '10px 20px',
              borderRadius: '12px',
              border: '1px solid rgba(138, 43, 226, 0.2)'
            }}>
              <span style={{ fontSize: '1.2rem' }}>← Back to Members</span>
            </Link>
          </div>

          <div style={{
            textAlign: 'center',
            marginBottom: '50px'
          }}>
            <h1 style={{ 
              fontSize: '3rem',
              marginBottom: '20px',
              background: 'linear-gradient(45deg, #8a2be2, #4a90e2)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}>
              AI Video Generator <span style={{
                background: '#4CAF50',
                color: 'white',
                padding: '4px 12px',
                borderRadius: '12px',
                fontSize: '1rem',
                verticalAlign: 'middle',
                marginLeft: '10px'
              }}>BETA</span>
            </h1>
          </div>

          {!account ? (
            <div style={{
              background: 'rgba(138, 43, 226, 0.1)',
              padding: '40px',
              borderRadius: '20px',
              textAlign: 'center',
              border: '1px solid rgba(138, 43, 226, 0.2)',
              maxWidth: '500px',
              margin: '40px auto'
            }}>
              <img src={logo} alt="Logo" style={{ width: '80px', marginBottom: '20px' }} />
              <h2 style={{ marginBottom: '20px', color: '#8a2be2' }}>Connect Your Wallet</h2>
              <p style={{ marginBottom: '30px', color: 'rgba(255,255,255,0.8)' }}>
                Connect your wallet to start generating AI videos
              </p>
              <button
                onClick={connectWallet}
                disabled={loading}
                style={{
                  background: loading ? 'rgba(138, 43, 226, 0.5)' : '#8a2be2',
                  color: 'white',
                  border: 'none',
                  padding: '15px 30px',
                  borderRadius: '12px',
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  width: '100%',
                  maxWidth: '300px'
                }}
              >
                {loading ? 'Connecting...' : 'Connect Wallet'}
              </button>
              {error && (
                <div style={{
                  color: '#ff4444',
                  marginTop: '20px',
                  fontSize: '0.9rem'
                }}>
                  {error}
                </div>
              )}
            </div>
          ) : (
            <div style={{
              maxWidth: '800px',
              margin: '0 auto'
            }}>
              <TextToVideo />
            </div>
          )}
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default VideoPage; 